import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {InitialImportDialogState} from '../../components/Marketplace/ImportDialogs/ImportDialog';

type DialogState = {
  isOpen: boolean;
  isCancelled: boolean;
  initialMarketplaceState: InitialImportDialogState;
};

const initialState: DialogState = {
  isOpen: false,
  isCancelled: false,
  initialMarketplaceState: {},
};

const addDataDialogSlice = createSlice({
  name: 'marketplace-add-data',
  initialState,
  reducers: {
    setIsOpen: (
      state,
      action: PayloadAction<{
        isOpen: DialogState['isOpen'];
        isCancelled?: boolean;
        initialMarketplaceState?: InitialImportDialogState;
      }>
    ) => {
      state.isOpen = action.payload.isOpen;
      state.isCancelled = Boolean(action.payload.isCancelled);
      state.initialMarketplaceState =
        action.payload.isOpen && action.payload.initialMarketplaceState
          ? action.payload.initialMarketplaceState
          : initialState.initialMarketplaceState;
    },
  },
});

export const {reducer: addDataDialogReducer, actions} = addDataDialogSlice;
